export default "__VITE_ASSET__CeJIRBRK__"